import { Search, X } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

const ALL = "all";

function FilterSelect({ value, onChange, placeholder, options, testId }) {
  return (
    <Select value={value || ALL} onValueChange={(v) => onChange(v === ALL ? "" : v)}>
      <SelectTrigger className="h-9 w-[170px] bg-white" data-testid={testId}><SelectValue placeholder={placeholder} /></SelectTrigger>
      <SelectContent>
        <SelectItem value={ALL}>{placeholder}</SelectItem>
        {options.map(([v, l]) => <SelectItem key={v} value={v}>{l}</SelectItem>)}
      </SelectContent>
    </Select>
  );
}

export function ResourceFilters({ meta, filters, onChange, showStatus }) {
  const set = (patch) => onChange({ ...filters, ...patch });
  const statuses = [["draft", "Draft"], ["in_review", "In review"], ["approved", "Approved"], ["archived", "Archived"]];
  const active = Object.values(filters).some(Boolean);
  return (
    <div className="flex flex-wrap items-center gap-2" data-testid="resource-filters">
      <div className="relative min-w-[240px] flex-1">
        <Search className="pointer-events-none absolute left-2.5 top-2.5 h-4 w-4 text-zinc-400" />
        <Input value={filters.q} onChange={(e) => set({ q: e.target.value })} placeholder="Search title, description, tags, categories"
               className="h-9 bg-white pl-8" data-testid="resource-search-input" />
      </div>
      <FilterSelect value={filters.category} onChange={(v) => set({ category: v })} placeholder="All categories"
                    options={meta.categories.map((c) => [c.key, c.label])} testId="resource-filter-category" />
      {showStatus && <FilterSelect value={filters.status} onChange={(v) => set({ status: v })} placeholder="Active statuses"
                                   options={statuses} testId="resource-filter-status" />}
      {meta.programs.length > 0 && <FilterSelect value={filters.program} onChange={(v) => set({ program: v })}
                                                 placeholder="All programs" options={meta.programs.map((p) => [p, p])}
                                                 testId="resource-filter-program" />}
      {showStatus && <FilterSelect value={filters.review} onChange={(v) => set({ review: v })} placeholder="Any review date"
                                   options={[["overdue", "Review overdue"], ["due_soon", "Due in 30 days"]]}
                                   testId="resource-filter-review" />}
      {active && (
        <button type="button" onClick={() => onChange({ q: "", category: "", status: "", program: "", review: "" })}
                className="inline-flex items-center gap-1 text-xs text-zinc-500 hover:text-zinc-900" data-testid="resource-filters-clear">
          <X className="h-3 w-3" /> Clear
        </button>
      )}
    </div>
  );
}
